import React from "react";
// import { Link } from "react-router-dom";




export default class News extends React.Component {

    render(){
        return(
            <div>
                <div class="wrapper">
                    <section class="bread-crumb-container">
                        <div class="bread-crumb-img">
                            <img src="/assets/images/bread-crumb5.png" alt=""/>
                        </div>
                        <div class="bread-crumb-content">
                            <div class="bread-crumb-inner">
                            <h2>Post Detail</h2>
                            <a href="index.html">Home</a> - <a href="post-detail.html">Post Detail</a>
                            </div>
                        </div> {/* <!-- bread-crumb-content --> */}
                    </section> {/* <!-- bread-crumb-container --> */}
                    <div class="main-part">
                    <section class="event-container">
                        <div class="container">
                        <div class="post-detail">
                            <div class="row">
                            <div class="col-md-9 col-sm-9 col-xs-12">
                                <div class="event-detail-wrap">
                                <div class="event-list wow fadeInDown text-left" data-wow-duration="1000ms" data-wow-delay="300ms">
                                    <div class="event-pic">
                                    <img src="/assets/images/event1.jpg" alt=""/>
                                    </div>
                                    <h3>Wedding with our food truck</h3>
                                    <span>17 august 2016 - </span><a href="#/">Weddings</a>
                                    <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.</p>
                                    <p>Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.</p>
                                    <p>Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem.</p>
                                    <div class="tags"><span>TAGS:</span> food, weddings, truck</div>
                                    <div class="post-link">
                                    <div class="post-left-link">
                                        <a href="#/">Previous post</a>
                                    </div>
                                    <div class="post-right-link">
                                        <a href="#/">Next post</a>
                                    </div>
                                    </div>
                                </div> {/* <!-- event-list --> */}
                                </div> {/* <!-- event-wrap --> */}
                                <div class="post-comment-container text-left">
                                <h3>Comments</h3>
                                <div class="post-comment-list">
                                    <div class="post-prof">
                                    <img src="/assets/images/post-prof.jpg" alt=""/>
                                    </div>
                                    <div class="post-comment-content">
                                    <h6>Jack says:</h6>
                                    <span>17 - august - 2016</span>
                                    <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. </p>
                                    <a href="#/" class="btn-black">Reply</a>
                                    </div> {/* <!-- post-comment-content --> */}
                                </div> {/* <!-- post-comment-list --> */}
                                <div class="post-comment-list">
                                    <div class="post-prof">
                                    <img src="/assets/images/post-prof.jpg" alt=""/>
                                    </div>
                                    <div class="post-comment-content">
                                    <h6>Jack says:</h6>
                                    <span>17 - august - 2016</span>
                                    <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. </p>
                                    <a href="#/" class="btn-black">Reply</a>
                                    </div> {/* <!-- post-comment-content --> */}
                                </div> {/* <!-- post-comment-list --> */}
                                </div> {/* <!-- post-comment-container --> */}
                                <div class="post-form">
                                <div class="row">
                                    <div class="col-md-6 col-sm-6 col-xs-12">
                                    <div class="form-field">
                                        <input name="txt" placeholder="* Name" type="text"/>
                                    </div> {/* <!-- form-field --> */}
                                    <div class="form-field">
                                        <input name="txt" placeholder="* Email" type="email"/>
                                    </div> {/* <!-- form-field --> */}
                                    </div>
                                    <div class="col-md-6 col-sm-6 col-xs-12">
                                    <div class="form-field">
                                        <textarea placeholder="* comment"></textarea>
                                    </div> {/* <!-- form-field --> */}
                                    </div>
                                    <div class="col-md-6 col-sm-6 col-xs-12">
                                    <div class="form-field post-button-btn">
                                        <button class="btn-black">Send message</button>
                                    </div> {/* <!-- form-field --> */}
                                    </div>
                                </div>
                                </div> {/* <!-- post-form --> */}
                            </div>
                            <div class="col-md-3 col-sm-3 col-xs-12">
                                <div class="post-detail-right">
                                <div class="post-right-search">
                                    <form method="post" name="form">
                                    <div class="form-field">
                                        <input name="txt" placeholder="Type here..." type="text"/>
                                    </div>
                                    <div class="form-field text-left">
                                        <button class="btn-black">Search</button>
                                    </div> {/* <!-- form-field --> */}
                                    </form>
                                </div> {/* <!-- post-right-search --> */}
                                <div class="post-categories text-left">
                                    <h3>Categories</h3>
                                    <ul>
                                    <li><a href="#/">Weddings</a></li>
                                    <li class="active"><a href="#/">Food</a></li>
                                    <li><a href="#/">Our truck</a></li>
                                    <li><a href="#/">Recent events</a></li>
                                    <li><a href="#/">On road</a></li>
                                    </ul>
                                </div> {/* <!-- post-categories --> */}
                                <div class="post-categories text-left">
                                    <h3>Recent posts</h3>
                                    <ul>
                                    <li><a href="#/">What to do on wedding</a></li>
                                    <li class="active"><a href="#/">Food tips</a></li>
                                    <li><a href="#/">Our truck events</a></li>
                                    <li><a href="#/">A new adventure</a></li>
                                    <li><a href="#/">People meet on road</a></li>
                                    </ul>
                                </div>{/* <!-- post-categories --> */}
                                <div class="post-gallery gallery clearfix text-left">
                                    <h3>Gallery</h3>
                                    <div class="post-gallery-item">
                                    <a href="images/post-gallery-big1.jpg" rel="prettyPhoto[gallery1]"><img src="/assets/images/post-gallery1.jpg" alt=""/></a>
                                    </div>
                                    <div class="post-gallery-item">
                                    <a href="images/post-gallery-big2.jpg" rel="prettyPhoto[gallery1]"><img src="/assets/images/post-gallery2.jpg" alt=""/></a>
                                    </div>
                                    <div class="post-gallery-item">
                                    <a href="images/post-gallery-big3.jpg" rel="prettyPhoto[gallery1]"><img src="/assets/images/post-gallery3.jpg" alt=""/></a>
                                    </div>
                                </div> {/* <!-- post-gallery --> */}
                                </div> {/* <!-- post-detail-right --> */}
                            </div>
                            </div>
                            </div> {/* <!-- post-detail --> */}
                        </div>
                    </section> {/* <!-- event-container --> */}
                    <div class="map-outer">
                        <div id="truck-locator"></div>
                    </div>
                    </div> {/* <!-- main-part --> */}
                            
                </div>
            </div>
        )
    }
}